import { render, staticRenderFns } from "./SalesMonitor.vue?vue&type=template&id=6b6eae4b&scoped=true&"
import script from "./SalesMonitor.vue?vue&type=script&lang=js&"
export * from "./SalesMonitor.vue?vue&type=script&lang=js&"
import style0 from "./SalesMonitor.vue?vue&type=style&index=0&id=6b6eae4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6eae4b",
  null
  
)

export default component.exports